export enum SalesDisplayMode {
    yearly = 'yearly',
    monthly = 'monthly',
    weekly = 'weekly',
    daily = 'daily',
}
